import { IconButton } from '@mui/material'
import React from 'react'
import { useNavigate, useLocation } from 'react-router'
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded'
import { BackIconButtonProps } from './type'

const getPreviousPath = (pathname): string => {
  const previousPath = pathname.split('/')
  previousPath.pop()
  if (previousPath.length > 2) return `/${previousPath[1]}`
  return previousPath.join('/')
}

export const BackIconButton: React.FC<BackIconButtonProps> = ({ to = null, ...props }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const handleClick = (): void => {
    if (to) {
      navigate(to)
      return
    }
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1)
    } else {
      const previousPath = getPreviousPath(pathname)
      navigate(previousPath)
    }
  }
  return (
    <IconButton color='primary' size='medium' {...props} onClick={handleClick}>
      <ArrowBackIosRoundedIcon />
    </IconButton>
  )
}
